@if (loading.invoiceHeader) {
  <div id="loadingInvoiceContainer" class="overlay full">
    <p class="text-center">{{ appStrings.loadingInvoiceDetails }}</p>
    <ds-progress-spinner id="invoiceDetailsLoader"></ds-progress-spinner>
  </div>
}

@if (loading.trackingInformation) {
  <div id="loadingTrackingInfo" class="overlay full">
    <p class="text-center">{{ appStrings.loadingTrackingInfo }}</p>
    <ds-progress-spinner id="trackingInfoLoader"></ds-progress-spinner>
  </div>
}

@if (!importQuoteActive && !isMobile) {
  <div class="header-container">
    <div class="header-title">
      <typography id="invoiceTitle" variant="mat-headline-4" weight="bold">{{ appStrings.quote_ens_invoice }}</typography>
      <typography id="invoiceSeparator" variant="mat-headline-4" weight="bold">|</typography>
      <typography id="invoiceNumberLabel" variant="mat-headline-4" weight="bold">
        {{ appStrings.invoice_number }} -
      </typography>
      <typography id="invoiceNumberValue" variant="mat-headline-4" weight="bold">
        {{ invoiceNumber }}
      </typography>
    </div>
    <div class="header-buttons">
      <ds-button class="quarter-width" size="large" type="secondary" variant="label-only" id="closeButton" (onClick)="close()"
        [label]="appStrings.button_close">
      </ds-button>
      <ds-button class="quarter-width" size="large" type="secondary" variant="label-only" id="printButton" (onClick)="printInvoice(invoiceNumber)"
        [label]="appStrings.button_print">
      </ds-button>
      <ds-button class="half-width" size="large" type="primary" variant="label-only" id="trackInvoiceButton" (onClick)="trackInvoice()"
        [label]="appStrings.invoice_trackButton">
      </ds-button>
    </div>
  </div>
}

@if (isMobile && isAccountDetails) {
  <div class="breadcrumb-container">
    <ds-breadcrumbs [breadcrumbs]="breadcrumbs" separatorType="slash" [collapsable]="false" [iconStyle]="isMobile ? 'material-icons-outlined' : null"></ds-breadcrumbs>
  </div>
}

@if (!importQuoteActive) {
  <div id="invoiceView" [ngClass]="{'view-container': isMobile}">
    @if (isMobile) {
      <div id="invoiceViewHeaderInvoiceNumber" class="invoice-view-header">
        <typography id="invoiceNumberLabel" variant="mat-headline-4" weight="bold">
          {{ appStrings.invoice_number }} -
        </typography>
        <typography id="invoiceNumberValue" variant="mat-headline-4" weight="bold">
          {{ invoiceNumber }}
        </typography>
      </div>
    }
    @if (isMobile) {
      <div class="mobile-buttons-container">
        <ds-button class="quarter-width" size="large" type="secondary" variant="label-only" id="closeButton" (onClick)="close()"
          [label]="appStrings.button_close">
        </ds-button>
        <ds-button class="quarter-width" size="large" type="secondary" variant="label-only" id="printButton" (onClick)="printInvoice(invoiceNumber)"
          [label]="appStrings.button_print">
        </ds-button>
      </div>
    }
    <div class="accordion-container">
      <mat-accordion id="invoiceContainer">
        <!-- Invoice Header Panel -->
        <mat-expansion-panel [expanded]="true" id="invoiceHeaderContainer" #invoiceHeaderContainer>
          <mat-expansion-panel-header id="invoiceHeaderExpansionPanel">
            <div id="invoiceHeaderTitle">
              <h2>{{ appStrings.invoice_header }}</h2>
            </div>
          </mat-expansion-panel-header>
          <app-invoice-header [invoiceHeaderResult]="invoiceHeaderDetails"></app-invoice-header>
        </mat-expansion-panel>
        <!-- Invoice Details Panel -->
        <mat-expansion-panel id="invoiceDetailsContainer" #invoiceDetailsContainer>
          <mat-expansion-panel-header id="invoiceDetailsExpansionPanel">
            <div id="invoiceDetailsTitle">
              <h2>{{ appStrings.invoice_details }}</h2>
            </div>
          </mat-expansion-panel-header>
          <app-invoice-details [invoiceNumber]="invoiceNumber" [currencySymbol]="invoiceHeaderDetails?.currencySign"></app-invoice-details>
        </mat-expansion-panel>
        <!-- Invoice Footer Panel -->
        <mat-expansion-panel id="invoiceFooterContainer" #invoiceFooterContainer>
          <mat-expansion-panel-header id="invoiceFooterExpansionPanel">
            <div id="invoiceFooterTitle">
              <h2>{{ appStrings.invoice_footer }}</h2>
            </div>
          </mat-expansion-panel-header>
          <app-invoice-footer [invoiceNumber]="invoiceNumber" [currencySymbol]="invoiceHeaderDetails?.currencySign"></app-invoice-footer>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    @if (!quoteIsCompleted && isMobile) {
      <div class="mobile-sticky-footer">
        <ds-button class="half-width" size="large" type="primary" variant="label-only" id="trackInvoiceButton" (onClick)="trackInvoice()"
          [label]="appStrings.invoice_trackButton">
        </ds-button>
      </div>
    }
  </div>
}
